
import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [andLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const listContent = [
    // Existing sections
    {
      id: 1,
      title: "What is a Digital Factory",
      nestedContent: [
        { id: 1, text: "• Definition and key principles.", dummyText: [] },
        { id: 2, text: "• Evolution from traditional to smart manufacturing.", dummyText: [] },
        { id: 3, text: "• Role in Industry 4.0 and beyond.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Importance of Digital Factory Solutions",
      nestedContent: [
        { id: 1, text: "• Enhancing productivity and efficiency.", dummyText: [] },
        { id: 2, text: "• Real-time monitoring and control.", dummyText: [] },
        { id: 3, text: "• Data-driven decision-making and predictive analytics.", dummyText: [] },
      ],
    },
  ];

  const newModuleContent = [
    // New module sections
    {
      id: 1,
      title: "Digital Twin Technology",
      nestedContent: [
        { id: 1, text: "• 	Definition and applications.", dummyText: [] },
        { id: 2, text: "• 	Creating virtual replicas of physical systems.", dummyText: [] },
        { id: 3, text: "• 	Benefits: Predictive maintenance, process optimization.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: " IoT and Connectivity",
      nestedContent: [
        { id: 1, text: "• 	Role of IoT in smart manufacturing.", dummyText: [] },
        { id: 2, text: "• 	Sensors, actuators and real-time data collection.", dummyText: [] },
        { id: 3, text: "• 	Protocols and standards for connectivity.", dummyText: [] },
      ],
    },
    {
        id: 3,
        title: " Automation and Robotics",
        nestedContent: [
          { id: 1, text: "• 		Integration of robotics in digital factories.", dummyText: [] },
          { id: 2, text: "• 		Collaborative robots (Cobots) and AGVs.", dummyText: [] },
          { id: 3, text: "• 		Use cases: Material handling, assembly lines.", dummyText: [] },
        ],
      },
      {
        id: 4,
        title: " Data Analytics and AI",
        nestedContent: [
          { id: 1, text: "• 		Data collection, processing and visualization.", dummyText: [] },
          { id: 2, text: "• 		Machine learning for predictive and prescriptive analytics", dummyText: [] },
          { id: 3, text: "• 		Case studies: AI-driven decision-making in manufacturing.", dummyText: [] },
        ],
      },
  ];

  const exteraModuleContent = [
    // Extra module sections
    {
      id: 3,
      title: " Overview of Common Tools",
      nestedContent: [
        { id: 1, text: "• 	Siemens Tecnomatix: Digital manufacturing and process simulation", dummyText: [] },
        { id: 2, text: "• 	Dassault DELMIA: Collaborative manufacturing operations.", dummyText: [] },
        { id: 3, text: "• PTC ThingWorx: IoT platform for smart factories.", dummyText: [] },
        { id: 4, text: "• 	Autodesk Fusion 360: Cloud-based design and manufacturing.", dummyText: [] },
      ],
    },
    {
      id: 4,
      title: " Hands-On Practice",
      nestedContent: [
        { id: 1, text: "• 	Setting up a virtual factory layout.", dummyText: [] },
        { id: 2, text: "• 	Real-time monitoring and control using IoT platforms.", dummyText: [] },
        { id: 3, text: "•	Data visualization and analytics with selected software.", dummyText: [] },
      ],
    },
  ];

  const additionalModuleContent = [
    // Additional module sections
    {
      id: 5,
      title: "Smart Manufacturing",
      nestedContent: [
        { id: 1, text: "•	Automated production lines and workflow optimization.", dummyText: [] },
        { id: 2, text: "•	Use of digital twins for real-time monitoring and adjustments.", dummyText: [] },
      ],
    },
    {
      id: 6,
      title: "Supply Chain Integration",
      nestedContent: [
        { id: 1, text: "• 	End-to-end visibility and traceability.", dummyText: [] },
        { id: 2, text: "•	Demand forecasting and inventory management.", dummyText: [] },
      ],
    },
    {
        id: 7,
        title: "Quality Control and Assurance",
        nestedContent: [
          { id: 1, text: "• 		Real-time defect detection using AI and IoT.", dummyText: [] },
          { id: 2, text: "•		Process validation and compliance tracking..", dummyText: [] },
        ],
      },
      {
        id: 8,
        title: "4 Energy Management",
        nestedContent: [
          { id: 1, text: "• 	Monitoring and reducing energy consumption.", dummyText: [] },
          { id: 2, text: "•		Sustainable manufacturing practices.", dummyText: [] },
        ],
      },
  ];

  const isExteraModuleContent = [
    // Additional Module Sections
    {
      id: 7,
      title: "Automation in Digital Factories",
      nestedContent: [
        { id: 1, text: "• Integration of automated processes.", dummyText: [] },
        { id: 2, text: "• Efficiency improvements and error reduction.", dummyText: [] },
      ],
    },
    {
      id: 8,
      title: "Data-Driven Manufacturing Insights",
      nestedContent: [
        { id: 1, text: "• Big data usage in manufacturing.", dummyText: [] },
        { id: 2, text: "• Real-time analytics for decision-making.", dummyText: [] },
      ],
    },
  ];

  const extraAdvancedModuleContent = [
    // Extra Advanced Module Sections
    {
      id: 9,
      title: "Planning and Strategy",
      nestedContent: [
        { id: 1, text: "•	Identifying needs and defining objectives.", dummyText: [] },
        { id: 2, text: "•	Selecting the right technologies and tools.", dummyText: [] },
      ],
    },
    {
      id: 10,
      title: " Integration with Existing Systems",
      nestedContent: [
        { id: 1, text: "• 	Challenges in legacy system integration..", dummyText: [] },
        { id: 2, text: "• 	Ensuring interoperability and scalability.", dummyText: [] },
      ],
    },
    {
      id: 11,
      title: "  Change Management",
      nestedContent: [
        { id: 1, text: "• 	Training employees for digital transformation..", dummyText: [] },
        { id: 2, text: "• 	Overcoming resistance to change and ensuring adoption.", dummyText: [] },
      ],
    },
  ];
  const andLocalModuleContent = [
    // Extra Advanced Module Sections
    {
      id: 9,
      title: "Simulation Exercises",
      nestedContent: [
        { id: 1, text: "•		Design a virtual factory layout", dummyText: [] },
        { id: 2, text: "•		Simulate production workflows and identify bottlenecks.", dummyText: [] },
      ],
    },
    {
      id: 10,
      title: " Case Studies",
      nestedContent: [
        { id: 1, text: "• 		Analysis of successful digital factory implementations.", dummyText: [] },
        { id: 2, text: "• 	Lessons learned and best practices", dummyText: [] },
      ],
    },
    {
      id: 11,
      title: "  Group Discussions and Q&A",
      nestedContent: [
        { id: 1, text: "• 		Identifying opportunities for digital transformation in participants’ industries.", dummyText: [] },
        { id: 2, text: "• 		Addressing challenges and exploring innovative solutions.", dummyText: [] },
      ],
    },
    {
      id: 11,
      title: " Capstone Project",
      nestedContent: [
        { id: 1, text: "• 			Design a digital twin for a manufacturing process.", dummyText: [] },
        { id: 2, text: "• 			Integrate IoT devices for real-time data collection and monitoring.", dummyText: [] },
        { id: 3, text: "• 			Optimize production workflows using analytics tools.", dummyText: [] },
        { id: 4, text: "• 				Implement a predictive maintenance model using AI.", dummyText: [] },
        { id: 5, text: "• 				Generate detailed reports on process efficiency and ROI.", dummyText: [] },
        { id: 6, text: "• 					Present the project findings and recommendations", dummyText: [] },
      ],
    },	
  ];

  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
      setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
    }
  };

  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4" style={{ color: "#000", fontFamily: "Roboto", textAlign: "center" }}>
        PROGRAM <span style={{ color: "rgb(251 145 0)" }}>OVERVIEW</span>
      </h2>
      <br />
      
      {/* Existing Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAllSections(!toggleAllSections)}
      >
        Introduction to Digital Factory Solutions
      </div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* New Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
       Components of a Digital Factory
      </div>

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Extera Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
        Software Tools for Digital Factories
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Additional Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
       Applications of Digital Factory Solutions
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

{/* <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleIsExteraModule)}
      >
       Applications of Digital Factory Solutions
      </div> */}

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{isExteraModuleContent[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleContent[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {/* Extra Advanced Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExtraAdvancedModule(!toggleExtraAdvancedModule)}
      >
        Implementation of Digital Factory Solutions
      </div>

      {toggleExtraAdvancedModule && (
        <div className="list-tab mt-3">
          {extraAdvancedModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extraAdvanced")}
              >
                {title}
                <span>{extraAdvancedModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {extraAdvancedModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
       <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAndLocalModule(!toggleAndLocalModule)}
      >
        Practical Exercises and Case Studies 
      </div>

      {toggleAndLocalModule && (
        <div className="list-tab mt-3">
          {andLocalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "andLocal")}
              >
                {title}
                <span>{andLocalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {andLocalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LearningPathTFD;




